<footer class="footer">
    <div class="footer-container">
      <div class="footer-content">
        <ul class="footer-links">
          <li><a href="#" class="footer-link">About</a></li>
          <li><a href="#" class="footer-link">Privacy Policy</a></li>
          <li><a href="#" class="footer-link">Licensing</a></li>
          <li><a href="#" class="footer-link">Contact</a></li>
        </ul>
      </div>
      <hr class="footer-divider" />
      <span class="footer-copy">
        © 2025 <a href="https://flowbite.com/" class="footer-link">Eco-turismo™</a>. All Rights Reserved.
      </span>
    </div>
  </footer>
  